import React from "react";
import { Link } from "react-router-dom";
import EditContactName from "./EditContactName";
import useStateCallback from "../../util/customHooks/useStateCallback";
import DeleteContact from "./DeleteContact";
import Loader from "../Common/Loader";
import BlockContact from "./BlockContact";
import UnblockContact from "./UnblockContact";
import DisapproveGuardianSetting from "./DisapproveGuardianSetting";
import ApproveGuardianSetting from "./ApproveGuardianSetting";
import { RenderSecure } from "../../util/script/RenderSecure";

function StudentContacts({studentContacts, getStudentContacts, countStudentContacts, loading}) {
  const [modal, setModal] = useStateCallback(false);


    const editContact = (e, item) => {
        setModal(false, () =>
          setModal(
            <EditContactName
              linkID={item.contact_entry_id}
              contactName = {item.contact_name}
              g={getStudentContacts}
              isOpen={true}
            />
          )
        );
    };

    const deleteContact = (e, item) => {
        setModal(false, () =>
          setModal(
            <DeleteContact
              contactID={item.link_id}
              g={getStudentContacts}
              h={countStudentContacts}
              isOpen={true}
            />
          )
        );
    };

    const blockContact = (e, item) => {
        setModal(false, () =>
          setModal(
            <BlockContact
              contactID={item.link_id}
              g={getStudentContacts}
              isOpen={true}
            />
          )
        );
    };

    const unblockContact = (e, item) => {
        setModal(false, () =>
          setModal(
            <UnblockContact
              contactID={item.link_id}
              g={getStudentContacts}
              isOpen={true}
            />
          )
        );
    };

    const removeSetGuardian= (e, item) => {
      setModal(false, () =>
        setModal(
          <DisapproveGuardianSetting
            contactID={item.link_id}
            g={getStudentContacts}
            isOpen={true}
          />
        )
      );
  };

  const addSetGuardian = (e, item) => {
      setModal(false, () =>
        setModal(
          <ApproveGuardianSetting
            contactID={item.link_id}
            g={getStudentContacts}
            isOpen={true}
          />
        )
      );
  };

    return (
        <>
        {modal}
        <div className="table-responsive">
        {loading? (
                                <Loader />
                            ) : (
                                <table className="table table-hover text-nowrap mg-b-2">
                                    <thead>
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col"> Names</th>
                                        <th scope="col"> Contact Number</th>
                                        <th scope="col"> Relationship</th>
                                        <th scope="col"> Actions</th>

                                    </tr>
                                    </thead>
                                    <tbody>
                                        {studentContacts.length > 0 ? (
                                            studentContacts.map((item, index) => (
                                                <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <td>{item.contact_name} {item.is_blocked==="1"?<i className="fa fa-ban ml-1" style={{ color: "#DE3163" }}></i>:""}</td>
                                                <td>{item.parent?.username} <span>{item.parent.user_id !=="0" && (
        <img 
        src={
            process.env.PUBLIC_URL +
            "/assets/img/appstore.png"
          } 
          alt="App User" 
          style={{ width: '16px', height: '18px', marginLeft: '2px'}} 
        />
      )}</span> </td>
                                                <td>{item.relationship}</td>
                                                <td>
                                                    <div className="dropdown">
                                                        <Link
                                                        to="#"
                                                        className="dropdown-toggle"
                                                        data-toggle="dropdown"
                                                        aria-expanded="false"
                                                        >
                                                        <span className="flaticon-more-button-of-three-dots"></span>
                                                        </Link>
                                                        <div className="dropdown-menu dropdown-menu-right" style={{overflowY:"auto", maxHeight:"150px"}}>
                                                            <Link
                                                            className="dropdown-item"
                                                            to="#"
                                                            onClick={(e) => editContact(e, item)}
                                                            >
                                                            <i className="far fa-edit mr-1" style={{ color: "orange" }}></i>
                                                            Edit Contact Name
                                                            </Link>
                                                            {item.is_blocked ==="1"?<Link
                                                            className="dropdown-item"
                                                            to="#"
                                                            onClick={(e) => unblockContact(e, item)}
                                                            >
                                                            <i className="fa fa-ban mr-1"></i>
                                                            Unblock Contact
                                                            </Link>:<Link
                                                            className="dropdown-item"
                                                            to="#"
                                                            onClick={(e) => blockContact(e, item)}
                                                            >
                                                            <i className="fa fa-ban mr-1"></i>
                                                            Block Contact
                                                            </Link>}
                                                            <Link
                                                            className="dropdown-item"
                                                            to="#"
                                                            onClick={(e) => deleteContact(e, item)}
                                                            >
                                                            <i className="fa fa-trash mr-1" style={{ color: "red" }}></i>
                                                            Delete Contact
                                                            </Link>
                                                            <RenderSecure code="ADMIN-VIEW">{item.is_admin ==="1"?<Link
                                                            className="dropdown-item"
                                                            to="#"
                                                            onClick={(e) => removeSetGuardian(e, item)}
                                                            >
                                                            <i className="fa fa-person-circle-minus mr-1"></i>
                                                            Disapprove Contact as Admin
                                                            </Link>:<Link
                                                            className="dropdown-item"
                                                            to="#"
                                                            onClick={(e) => addSetGuardian(e, item)}
                                                            >
                                                            <i className="fa fa-person-circle-check mr-1"></i>
                                                            Approve Contact as Admin
                                                            </Link>}</RenderSecure>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            ))
                                        ) : 
                                        (
                                            <tr>
                                                <td colSpan="5" style={{ textAlign: "center" }}>
                                                    No contacts added to this student yet.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}                 
        </div> </>
    );
}

export default StudentContacts;
